import request from '@/utils/request'

//统计各级别用户
export function sumUser() {
    let url = '/sum/user'
    return request.get(url)
}

//统计订单数 订单总额
export function sumOrder(){
    let url = '/sum/order'
    return request.get(url)
}